<script>
    import AlteryxService from "../services/alteryx.service";

    let importTypes = [
        {"key": "weekly", "label": "Weekly"},
        {"key": "monthly", "label": "Monthly"},
        {"key": "isr_employee_activity", "label": "ISR - Employee Activity"},
        {"key": "isr_employee_info", "label": "ISR - Employee Info"},
        {"key": "isr_pqp", "label": "ISR - Performance, Quota and Pipeline"},
        {"key": "sdr", "label": "SDR"}
    ];
    let loading = false;
    let files;
    let uploadingCSV = false;
    let message = {
        show: false,
        type: "",
        text: ""
    }
    let selectedType = "weekly";
    let uploadedError = "";
    let updatedSuccess = [];
    let updatedFailed = [];
    let showAlert = false;

    async function uploadCSV() {
        const formData = new FormData();
        formData.append('file', files[0]);
        uploadingCSV = true;
        uploadedError = "";
        loading = true;
        updatedSuccess = [];
        updatedFailed = [];

        try {
            const response = await AlteryxService.uploadCSV(formData, selectedType);
            if (response && response.data && response.data.ok) {
                if (response.data.result ) {
                    if (response.data.result.errors && response.data.result.errors.length > 0) {
                        updatedFailed = response.data.result.errors.map(error => {
                            const match = error.match(/Not found user: (\d+)/);
                            return match ? parseInt(match[1]) : null;
                        }).filter(id => id !== null);

                        if (updatedFailed.length > 0) {
                            updatedFailed = updatedFailed.join(", ");
                        } else {
                            updatedFailed = '<ul><li>' + response.data.result.errors.join('</li><li>') + '</li></ul>';
                        }
                    }

                    if (response.data.result.updated && response.data.result.updated.length > 0) {
                        updatedSuccess = response.data.result.updated.map(user => user.id);
                        updatedSuccess = updatedSuccess.filter((item, index) => {
                            return updatedSuccess.indexOf(item) === index;
                        });
                        updatedSuccess = updatedSuccess.join(", ");
                    }

                }
                message = {
                    show: true,
                    text: "CSV imported successfully",
                    type: "success"
                }
            } if (response.data && response.data.error) {
                message = {
                    show: true,
                    text: "Error: " + response.data.error,
                    type: "danger"
                }
            }
        } catch (e) {
            console.log('Error', e.toString());
            updatedFailed = e.toString();

            message = {
                show: true,
                text: "Error: " + e.message,
                type: "danger"
            }
        } finally {
            loading = false;
            showAlert = true;
            files = null;
        }
    }
</script>
<div id="upload">
    <div class="row">
        <div class="col-md-8 offset-2">
            <label>Select the report you want to import</label>
        </div>

        {#if showAlert}
            <div class="col-md-8 offset-2 position-relative border p-0">
                {#if updatedSuccess.length > 0}
                    <output class="alert alert-success d-block m-0"><strong>UPDATED: </strong>{updatedSuccess}</output>
                {/if}
                {#if updatedFailed.length > 0}
                    <output class="alert alert-danger d-block m-0"><strong>FAILED TO IMPORT: </strong>{@html updatedFailed}</output>
                {/if}
                <button type="button" class="close" aria-label="Close" on:click={ () => showAlert = false }><i class="fa fa-times"></i></button>
            </div>
        {/if}

        <div class="col-md-8 offset-2 mb-3 mt-3">
            {#each importTypes as type}
                <label class="d-block mr-2">
                    <input class="mr-1" type="radio" name="rbt_import" bind:group={selectedType} value="{type.key}">{type.label}
                    <a href="https://s3-us-west-2.amazonaws.com/new-riverside-kpis.seagage.com/{type.key}.csv" download class="btn btn-link">
                        <i class="fa fa-file-excel-o mr-1"></i>
                        Download Template
                    </a>
                </label>
            {/each}
        </div>
    </div>
    <div class="row">
        <div class="col-3 offset-2 pr-0">
            {#if loading}
                <input type="file" class="form-control-file bg-light rounded-right p-0" disabled={loading} placeholder="Uploading..." />
            {:else}
                <input type="file" class="form-control-file bg-light rounded-right p-0" disabled={loading} bind:files />
            {/if}
        </div>
        <div class="col-2">
            <button class="btn btn-success"
                    on:click={uploadCSV}
                    disabled={loading || !files}>
                {loading ? "Uploading..." : "Upload"}
            </button>
        </div>
        <div class="col-3 text-right">
            <a href="https://s3-us-west-2.amazonaws.com/new-riverside-kpis.seagage.com/Data+Import+Learning+Guide.pdf" target="_blank" class="btn btn-download">
                <i class="fa fa-book mr-1"></i>
                Read Learning Guide
            </a>
        </div>
    </div>
</div>
